import styled from "styled-components";
import {Flex} from "./flex";

export const FlexJustifyEnd = styled(Flex)`
    justify-content: flex-end;
`;
